import { render, staticRenderFns } from "./OrganisationAnalytics.vue?vue&type=template&id=16a8f95c&scoped=true"
import script from "./OrganisationAnalytics.vue?vue&type=script&lang=js"
export * from "./OrganisationAnalytics.vue?vue&type=script&lang=js"
import style0 from "./OrganisationAnalytics.vue?vue&type=style&index=0&id=16a8f95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8f95c",
  null
  
)

export default component.exports